// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__32bly","content":"Consent_content__34sbA","footer":"Consent_footer__1sbM1"};